import tasks from "@nextories/vue-tasks/src/i18n/langs/fr/tasks";

export default {
  ...tasks,
  table: {
    ...tasks.table,
    label: {
      ...tasks.table.label,
      moveStatus: 'Statut dém.',
    }
  },
};
